import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import Wmlogo from "../../assets/images/brand/workhub-logo-dark.svg"
import WmIcon from "../../assets/images/brand/workhub-icon.svg"

/* One rounded family, one icon per destination — no repeats. */
import GridViewRounded from '@mui/icons-material/GridViewRounded';
import AssignmentRounded from '@mui/icons-material/AssignmentRounded';
import SummarizeRounded from '@mui/icons-material/SummarizeRounded';
import PieChartRounded from '@mui/icons-material/PieChartRounded';
import TopicRounded from '@mui/icons-material/TopicRounded';
import GroupsRounded from '@mui/icons-material/GroupsRounded';
import BadgeRounded from '@mui/icons-material/BadgeRounded';
import ManageSearchRounded from '@mui/icons-material/ManageSearchRounded';
import BusinessCenterRounded from '@mui/icons-material/BusinessCenterRounded';
import PeopleAltRounded from '@mui/icons-material/PeopleAltRounded';
import HowToRegRounded from '@mui/icons-material/HowToRegRounded';
import AccessTimeRounded from '@mui/icons-material/AccessTimeRounded';
import EventAvailableRounded from '@mui/icons-material/EventAvailableRounded';
import RuleRounded from '@mui/icons-material/RuleRounded';
import EventNoteRounded from '@mui/icons-material/EventNoteRounded';
import PunchClockRounded from '@mui/icons-material/PunchClockRounded';
import DevicesOtherRounded from '@mui/icons-material/DevicesOtherRounded';
import SupportAgentRounded from '@mui/icons-material/SupportAgentRounded';
import ForumRounded from '@mui/icons-material/ForumRounded';
import DynamicFeedRounded from '@mui/icons-material/DynamicFeedRounded';
import AccountCircleRounded from '@mui/icons-material/AccountCircleRounded';
import StarRateRounded from '@mui/icons-material/StarRateRounded';



import './AdminNav.scss'
import '../AdminHeader/AdminHeader.scss'

const AdminNav = ({ toggle, setToggle, menu, user }) => {

  const location = useLocation()

  const MENU_ICONS = {
    '/dashBoard': GridViewRounded,          // overview grid
    '/status-report': AssignmentRounded,    // my work reports
    '/work-report': SummarizeRounded,       // team work reports
    '/project-report': PieChartRounded,     // project reports
    '/time-sheet': PunchClockRounded,       // hours clocked
    '/manage-projects': TopicRounded,       // project folders
    '/manage-team': GroupsRounded,          // teams
    '/manage-employees': BadgeRounded,      // people records
    '/searchskill': ManageSearchRounded,    // skill search
    '/jobs': BusinessCenterRounded,         // open roles
    '/pool': PeopleAltRounded,              // talent pool
    '/recruiter/list': HowToRegRounded,     // interview assignments
    '/attendance': AccessTimeRounded,       // attendance
    '/performance': StarRateRounded,        // reviews and ratings
    '/scheduleinterview': EventAvailableRounded,
    '/approvals': RuleRounded,              // decisions queue (now a tab)
    '/leaveRequests': EventNoteRounded,     // leaves & approvals
    '/asset-management': DevicesOtherRounded,
    '/help-desk': SupportAgentRounded,
    '/chat': ForumRounded,
    '/social-feed': DynamicFeedRounded,
    '/profile': AccountCircleRounded,
  };

  const getIcon = (pathname) => {
    const IconComponent = MENU_ICONS[pathname] || GridViewRounded;
    return <IconComponent className="sidebar-icons" />;
  }

  return (
    <div className={`sidebar ${toggle ? "sidebar--wide" : "sidebar--mini"}`}>
      <nav id="sidebar" >
        {
          toggle ? (
            <div className="sideNavbar_big">
              <NavLink to="/">
                <Tooltip title="Go To Home Page" placement="right" arrow>
                  <div className="d-flex justify-content-center p-3">
                    <img src={Wmlogo} alt="logo" className="" />
                  </div>
                </Tooltip>
              </NavLink>
              <hr className="text-white mt-0 mb-0"></hr>
              <div className="side_nav text-center">
                {menu.map((m, index) => (
                  <Link key={m.path} to={m.path}>
                    <div className={`nav-row d-flex align-items-center${location.pathname == m.path ? " is-active" : ""}`}>
                      <div className="nav-row-icon">
                        {getIcon(m.path)}
                      </div>
                      <h6 className="pull-left-text mx-2 my-3">{m.name}</h6>
                    </div>
                  </Link>
                ))}

              </div>
            </div>
          ) : (
            <div className="text-center">
              <div className="sideNavBar_small p-2 text-center">
                <div>
                  <div className="logo_small_letter pt-2 pb-1 px-1">
                    <div className="profile_icon brand_icon mb-2" onClick={() => setToggle(!toggle)}><img src={WmIcon} alt="WorkHub Manager" /></div>
                  </div>
                  <div>
                    {menu.map((m, index) => (
                      <Link key={m.path} to={m.path}>
                        <div className={`nav-row nav-row--mini d-flex align-items-center${location.pathname == m.path ? " is-active" : ""}`}>
                          <Tooltip title={m.name} placement='right' arrow>
                            <div className="nav-row-icon">
                              {getIcon(m.path)}
                            </div>
                          </Tooltip>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </nav>
    </div>
  );
};

export default AdminNav